module.exports = __webpack_public_path__ + "6ac9ecbbb4ffb5fa781b39db63f37504.jpg";